import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {findAttachment} from "../../../utils/awsAmplifyUtil";
import {Dict} from "../../../types/pj1dbApi";
import {AttachmentDocument} from "../../equipmentdb/types/pj1dbApiAttachment";

export interface UseConnectableAttachmentParams {
  handIds: string[];
  armId: string;
  enableAutoFetch?: boolean;
  initialStatus?: Status;
  onChange: (newData: Dict<AttachmentDocument> | null, newStatus: Status) => void;
}

export function useConnectableAttachment(params: UseConnectableAttachmentParams) {
  const result = useFetchAllQuery<Awaited<ReturnType<(typeof findAttachment)>>['data']>({
    queryFn: (query) => findAttachment({
      query: {
        handIds: {
          $regex: params.handIds.join("|"),
        },
        armIds: {
          $regex: params.armId,
        }
      }
    }, query),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helper = useFetchAllQueryHelper({
    onChange: () => {},
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  })

  return {
    ...result,
    ...helper,
  };
}
